import { Dispatch, ReactNode, SetStateAction } from 'react';
import { NavigateFunction } from 'react-router';
import { store } from 'Store';
import { ITableActionTopbarButton } from 'Components/UI/TableActionTopbar';
import {
  ListagemArquivosActions,
  ListagemArquivosActionUnion,
} from 'Store/ListagemArquivos/ListagemArquivos.actions';
import { ISignalRArchive, IUploadFileData } from 'Data/interfaces/Upload/IUploadFileData';
import { UploadActions } from 'Store/Upload/Upload.actions';
import {
  SeparatorsData,
  IVersionField,
} from 'Data/interfaces/Nomenclatura/INomenclatureData';
import { IFileRenameData } from 'Data/interfaces/ListagemArquivos/IFileRenameRequest';
import { IUpdateFileInfoRequest } from 'Data/interfaces/Obra/IUpdateFileInfoRequest';
import { IUpdateFilesStatusRequest } from 'Data/interfaces/Obra/IUpdateFilesStatusRequest';
import {
  IFileData,
  IBreadCrumbItem,
  FileStatusEnum,
} from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import { msplit } from 'Utils/toolBox';
import Tag from 'Components/UI/Tag';
import { ColorName } from 'Utils/Color';
import { IObraData } from 'Data/interfaces/Obra/IObraData';
import { IBreadCrumbItem as IBreadcrumbItemResponse } from 'Data/interfaces/ListagemArquivos/IListFilesResponse';
import { ITipoOption } from './Modals/FilterModal';
import AccessPermission from 'Utils/AcessPermission';
import toastHandler from 'Utils/toastHandler';
import Tooltip from 'Components/UI/Tooltip';
import {
  HAS_LOCKED_FILES_REQUEST_PLOT,
  HAS_LOCKED_FILES_REQUEST_PLOT_EXTENSION,
} from 'Utils/Messages';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { ViewerActions } from 'Store/Viewer/Viewer.actions';
import { IAutodeskViewer } from 'Data/interfaces/Viewer/IAutodeskViewer';
import { GetDisciplineApiFolderIdFromBreadCrumb } from 'Utils/ObraUtils';
import { extensions2dAnd3d, allOtherExtensions } from 'Utils/ViewerUtils';
import { getIconApi, ApisEnumLabel } from 'Data/enums/Apis';
import { IListFilesRequest } from 'Data/interfaces/ListagemArquivos/IListFilesRequest';
import { Icon, IconName } from 'Components/UI';
import AppStorage from 'Utils/AppStorage';
import { ISharedUser } from 'Data/interfaces/User/ISharedUser';
import { IOpenVisualizationBlockedFileAction } from '.';
import ModalBloquedSADownload from 'Components/UI/ModalBloquedSADownload';
import QRCodePosition from './Components/QRCodePosition';
import { QRCodePositionEnum } from 'Data/interfaces/Plotagem/IPlotRequestRequest';
import LotePlotagens from './Components/LotePlotagens';
import { Mixpanel } from 'Utils/MixPanel';
import { IUserInforResponse } from 'Data/interfaces/Auth/IUserInfoResponse';
import { ITenantData } from 'Data/interfaces/Tenant/ITenantData';
import { v4 as uuid } from 'uuid';
import { IRequestPlotColumns, RESIZABLE_COLUMN_IDS } from './ListagemArquivos.columns';
import { setFileStatusRendering } from 'Hooks/files/useQueryFiles';
import { IListFilesOrder } from 'Data/interfaces/ListagemArquivos/ISortListFiles';
import { SortOrder } from 'antd/es/table/interface';
import { IListDisciplinesOrder } from 'Data/interfaces/Obra/ISortListDisciplines';
import styles from './ListagemArquivos.module.scss';

import emptyListImage from 'Static/images/computer-upload.png';
import { resetFileStatusRendering } from 'Hooks/files/useQueryVerifyAutodeskProfressFiles';

export interface IButtonsTableToolbar {
  preferencesFeature?: boolean;
  showEditTable: boolean;
  selectedRowKeys: string[];
  selectedFiles: any[];
  listFiles: IFileData[];
  obra: IObraData;
  ConstructionSiteDisciplinesId: number;
  isDownloading?: boolean;
  ObsoleteFolderId?: string;
  breadCrumbItemId?: number | string;
  isObsoleteFolder?: boolean;
  constructionSiteId: number;
  folderId: string;
  folderName?: string;
  disciplineName?: string | null;
  urlFolder?: string;
  platform: number;
  breadCrumbPreviousItemId: string | null;
  planIsFree?: boolean;
  isLoadingFilesObsoleteList?: boolean;
  currentUserPrivileges?: ISharedUser;
  userInfo?: IUserInforResponse;
  currentTenant?: ITenantData | null;
  tenantIds?: number[];
  flags: {
    downloadViaStream?: boolean;
  };
  openModalExclusaoArquivos?: () => void;
  openModalDownloadMultiplesFiles?: (hasFolder: boolean) => void;
  openModalDownloadBlockedFiles?: (
    hasPermission: boolean,
    isBlocked: boolean,
    hasBlockedFolders: boolean,
    hasMultipleFiles: boolean,
  ) => void;
  onDownload?: () => void;
  desarquivarArquivos?: () => void;
  openModalCriarPasta?: (file?: IFileData) => void;
  dispatch: Dispatch<ListagemArquivosActionUnion>;
  updateFileInfo: (values: IUpdateFileInfoRequest) => void;
  updateFilesStatus: (values: IUpdateFilesStatusRequest) => void;
  navigate: NavigateFunction;
  onOpenHistoryDrawer: (fileData?: IFileData) => void;
  onToggleFollowFolder: (files: IFileData[]) => void;
  onRefetchFiles: () => void;
  onOpenModalMoveFiles: () => void;
  resetResizableColumns: (clearStorage?: boolean) => void;
}

export interface IListSaveOrder {
  dataIndex: string;
  sortOrder: boolean;
}

export const updateUploadState = (
  files: FileList | null,
  params: any,
  obra: IObraData,
  breadCrumbItem: IBreadCrumbItem,
  dispatch: Dispatch<any>,
  ConstructionSiteDisciplinesId?: number,
  maxQtyUploadFiles?: number,
  onOpenModalUpgradeUpload?: () => void,
  folderName?: string | null,
  disciplineName?: string | null,
) => {
  if (files) {
    const disciplineApiFolderId = GetDisciplineApiFolderIdFromBreadCrumb(breadCrumbItem);
    const {
      constructionSiteId,
      folderId,
    } = params;

    const breadCrumbId = (breadCrumbItem?.PreviousItem?.BreadCrumbItemId &&
      breadCrumbItem.PreviousItem?.BreadCrumbItemId > 0)
      ? breadCrumbItem.PreviousItem.BreadCrumbItemId
      : null;
    const breadCrumbIdDropbox = (breadCrumbItem.PreviousItem?.BreadCrumbItemIdDropbox &&
      !breadCrumbItem.PreviousItem.BreadCrumbItemIdDropbox.includes('00000000-0000-0000-0000-000000000000'))
      ? breadCrumbItem.PreviousItem.BreadCrumbItemIdDropbox
      : null;

    const { uploadFileList } = store.getState().upload;
    const uploadFiles: IUploadFileData[] = Object.keys(files)
      .filter((key: any) => files[key].size)
      .map((key: any) => {
        const fileIdUpload = uuid();
        return {
          csId: constructionSiteId || obra.ConstructionSiteId,
          folderId: folderId || breadCrumbItem.Identifier,
          trackFolderName: folderName,
          disciplineApiFolderId,
          trackDisciplineName: disciplineName,
          file: files[key],
          isSending: false,
          sentSize: 0,
          totalSize: files[key].size,
          uploadCompleted: false,
          Api: obra.Api,
          inViewer: false,
          constructionSiteDisciplineId: ConstructionSiteDisciplinesId,
          uploadBreadcrumbFile: {
            fileParentId: breadCrumbItem.Identifier,
            fileParentBreadcrumbId: breadCrumbId || breadCrumbIdDropbox,
          },
          fileIdUpload,
        } as IUploadFileData;
      });

    if (maxQtyUploadFiles) {
      if (onOpenModalUpgradeUpload && uploadFileList) {
        if (uploadFileList.length > maxQtyUploadFiles) {
          onOpenModalUpgradeUpload();
        }
      }

      if (onOpenModalUpgradeUpload && (uploadFiles.length > maxQtyUploadFiles)) {
        onOpenModalUpgradeUpload();
      }

      if (uploadFiles.length <= maxQtyUploadFiles) {
        dispatch(UploadActions.addNewUploadFiles(uploadFiles));
      }
    } else {
      dispatch(UploadActions.addNewUploadFiles(uploadFiles));
    }
  }
};

export const renameFile = (
  values: any,
  breadCrumbItem: IBreadcrumbItemResponse,
  renameFileFn: (values: IFileRenameData) => void,
) => {
  let newName = '';
  if (values.hasNomenclatureControl === 'true') {
    for (let i = 0; values[`field${i}`] !== undefined; i++) {
      newName += `${values[`field${i}`]}${values[`separator${i}`]}`;
    }
    newName = newName.substr(0, newName.length - 1);
  } else {
    newName = values.simpleFileName;
  }
  const request: IFileRenameData = {
    ConstructionSiteId: values.constructionSiteId,
    FileId: values.fileId,
    OldName: values.oldName,
    NewName: `${newName}.${values.extension}`,
    FolderId: breadCrumbItem.Identifier,
    constructionSiteDisciplineId: values.constructionSiteDisciplineId,
  };
  renameFileFn(request);
};

export const saveOrderList = (
  saveKey: string,
  data: IListFilesOrder | IListDisciplinesOrder,
) => {
  AppStorage.SetItem(saveKey, JSON.stringify(data));
};

export const setTag = (text: string, color: ColorName) => <Tag color={color}>{text}</Tag>;

export const getValueField = (
  text: string,
  ordem: number,
  versionFields: IVersionField[],
) => {
  const fileNameWithoutExtension = text
    .split('.')
    .slice(0, -1)
    .join('.');
  const separators = versionFields.map(
    (field) => SeparatorsData.get(field.Separador)?.Value ?? '',
  );
  const fileNameDivisions = msplit(fileNameWithoutExtension, separators);

  return fileNameDivisions ? fileNameDivisions[ordem] : '';
};

export const getButtonsTableToolbar: (
  input: IButtonsTableToolbar,
) => ITableActionTopbarButton[] = ({
  preferencesFeature,
  showEditTable,
  selectedRowKeys,
  selectedFiles,
  obra,
  ConstructionSiteDisciplinesId,
  listFiles,
  dispatch,
  updateFileInfo,
  updateFilesStatus,
  navigate,
  openModalExclusaoArquivos,
  openModalDownloadMultiplesFiles,
  openModalDownloadBlockedFiles,
  onDownload,
  desarquivarArquivos,
  openModalCriarPasta,
  isDownloading,
  ObsoleteFolderId,
  breadCrumbItemId,
  isObsoleteFolder,
  constructionSiteId,
  folderId,
  folderName,
  disciplineName,
  platform,
  urlFolder,
  breadCrumbPreviousItemId,
  planIsFree,
  isLoadingFilesObsoleteList,
  currentUserPrivileges,
  userInfo,
  currentTenant,
  tenantIds,
  onOpenHistoryDrawer,
  flags,
  onToggleFollowFolder,
  onRefetchFiles,
  onOpenModalMoveFiles,
  resetResizableColumns,
}) => {
    if (showEditTable) {
      return [
        {
          icon: 'voltar',
          iconCustomSize: 10,
          description: 'Voltar para info',
          action: () => {
            dispatch(ListagemArquivosActions.setShowEditTable(false));
          },
        },
      ];
    }

    if (selectedRowKeys && selectedRowKeys.length) {
      return getSelectedToolbar({
        showEditTable,
        selectedRowKeys,
        selectedFiles,
        ConstructionSiteDisciplinesId,
        obra,
        listFiles,
        dispatch,
        updateFileInfo,
        updateFilesStatus,
        navigate,
        openModalExclusaoArquivos,
        openModalDownloadMultiplesFiles,
        openModalDownloadBlockedFiles,
        onDownload,
        desarquivarArquivos,
        openModalCriarPasta,
        isDownloading,
        isObsoleteFolder,
        constructionSiteId,
        folderId,
        platform,
        urlFolder,
        breadCrumbPreviousItemId,
        planIsFree,
        currentUserPrivileges,
        onOpenHistoryDrawer,
        flags,
        onToggleFollowFolder,
        onOpenModalMoveFiles,
        preferencesFeature,
        onRefetchFiles,
        resetResizableColumns,
      });
    } else {
      return getDefaultToolbar({
        showEditTable,
        selectedRowKeys,
        selectedFiles,
        obra,
        ConstructionSiteDisciplinesId,
        listFiles,
        ObsoleteFolderId,
        breadCrumbItemId,
        openModalCriarPasta,
        dispatch,
        updateFileInfo,
        updateFilesStatus,
        navigate,
        constructionSiteId,
        folderId,
        folderName,
        disciplineName,
        platform,
        urlFolder,
        breadCrumbPreviousItemId,
        isLoadingFilesObsoleteList,
        currentUserPrivileges,
        userInfo,
        currentTenant,
        tenantIds,
        onOpenHistoryDrawer,
        flags,
        onToggleFollowFolder,
        onOpenModalMoveFiles,
        preferencesFeature,
        onRefetchFiles,
        resetResizableColumns,
      });
    }
  };

const getSelectedToolbar: (input: IButtonsTableToolbar) => ITableActionTopbarButton[] = ({
  selectedRowKeys,
  selectedFiles,
  listFiles,
  obra,
  constructionSiteId,
  dispatch,
  updateFileInfo,
  updateFilesStatus,
  navigate,
  openModalExclusaoArquivos,
  openModalDownloadMultiplesFiles,
  openModalDownloadBlockedFiles,
  onDownload,
  desarquivarArquivos,
  openModalCriarPasta,
  isDownloading,
  showEditTable,
  isObsoleteFolder,
  folderId,
  breadCrumbPreviousItemId,
  planIsFree,
  currentUserPrivileges,
  onOpenHistoryDrawer,
  flags,
  onToggleFollowFolder,
  onOpenModalMoveFiles,
  preferencesFeature,
}) => {
  const hasReleasedFile = listFiles
    .filter((file) => selectedRowKeys.includes(file.Identifier.ApiId || file.Identifier.ItemId))
    .some((file) => file.Status === 1);
  const hasUploadError = () => selectedFiles.some((file) => file.UploadRenderingStatus?.archiveStatus === 'error');
  const hasFollowedFolder = selectedFiles.some((file) => file.IsFollow);

  return [
    {
      icon: 'history',
      iconCustomSize: 22,
      description: 'Histórico',
      hidden: selectedRowKeys.length !== 1,
      action: () => {
        onOpenHistoryDrawer();
      },
    },
    {
      icon: hasFollowedFolder ? 'notVisualizar' : 'visualizar',
      iconCustomSize: hasFollowedFolder ? 18 : 12,
      description: hasFollowedFolder ? `Deixar de seguir pasta${selectedFiles.length > 1 ? 's' : ''}` : `Seguir pasta${selectedFiles.length > 1 ? 's' : ''}`,
      hidden: !preferencesFeature || !AccessPermission.hasOnlyFolderSelected(listFiles),
      action: () => {
        onToggleFollowFolder(selectedFiles);
      },
    },
    {
      icon: 'mover',
      description: 'Mover para',
      hidden: isObsoleteFolder || !AccessPermission.editFiles(listFiles, currentUserPrivileges) || hasUploadError(),
      action: () => {
        onOpenModalMoveFiles();
      },
    },
    {
      icon: 'editar',
      description: 'Edição',
      hidden: isObsoleteFolder ||
        !AccessPermission.editSelectedFiles(listFiles, currentUserPrivileges) ||
        (selectedRowKeys.length === 1 && !AccessPermission.hasOnlyFolderSelected(listFiles)) ||
        hasUploadError() ||
        (selectedRowKeys.length > 1 && !AccessPermission.hasNoFolderSelected(listFiles)),
      action: () => {
        if (openModalCriarPasta && selectedRowKeys.length === 1 && AccessPermission.hasOnlyFolderSelected(listFiles)) {
          openModalCriarPasta(
            listFiles.find((file) => selectedRowKeys.includes(file.Identifier.ApiId || file.Identifier.ItemId)),
          );
        } else {
          dispatch(ListagemArquivosActions.setShowEditTable(!showEditTable));
        }
      },
    },
    {
      icon: 'trocarStatus',
      description: 'Trocar status',
      hidden: isObsoleteFolder || !AccessPermission.changeStatusFiles(currentUserPrivileges) || hasUploadError() || !AccessPermission.hasNoFolderSelected(listFiles),
      dropdownMenu: (toggleDropdown: () => void) =>
        getDropdownStatusChange(
          selectedRowKeys,
          listFiles,
          constructionSiteId,
          folderId,
          updateFilesStatus,
          toggleDropdown,
        ),
    },
    {
      icon: 'menuPlotagem',
      description: 'Solicitar plotagem',
      hidden: isObsoleteFolder ||
        !AccessPermission.requestPlotting(listFiles, currentUserPrivileges) ||
        !hasReleasedFile ||
        planIsFree ||
        hasUploadError(),
      action: () => {
        const hasLockedFiles = listFiles
          .filter((file) => selectedRowKeys.includes(file.Identifier.ApiId || file.Identifier.ItemId))
          .some((file) => file.Status === 0);
        let hasExtensionFiles = true;
        const extensions = [
          'dwg',
          'dxf',
          'dgn',
          'jpg',
          'pdf',
          'doc',
          'docx',
          'nwd',
          'mpp',
          'xlsm',
          'xlsx',
          'vsd',
          'vsdx',
        ];

        listFiles
          .filter((file) => selectedRowKeys.includes(file.Identifier.ApiId || file.Identifier.ItemId))
          .forEach((file) => {
            if (
              extensions.indexOf(file.Extension.toLocaleLowerCase()) === -1
            ) {
              hasExtensionFiles = false;
            }
          });

        if (hasLockedFiles) {
          toastHandler.showError(HAS_LOCKED_FILES_REQUEST_PLOT());
        }
        if (hasExtensionFiles) {
          dispatch(ListagemArquivosActions.setShowPlotRequestTable(true));
        } else {
          toastHandler.showError(HAS_LOCKED_FILES_REQUEST_PLOT_EXTENSION());
        }
      },
    },
    {
      icon: 'arquivar',
      description: 'Restaurar',
      hidden: !AccessPermission.deleteFiles(currentUserPrivileges) || !isObsoleteFolder || hasUploadError(),
      action: () => {
        if (desarquivarArquivos) {
          desarquivarArquivos();
        }
      },
    },
    {
      icon: 'excluir',
      hidden: !AccessPermission.deleteFiles(currentUserPrivileges),
      action: () => {
        if (openModalExclusaoArquivos) {
          openModalExclusaoArquivos();
        }
      },
    },
    {
      icon: 'download',
      hidden: !AccessPermission.downloadFiles(currentUserPrivileges) ||
        hasUploadError() ||
        (isObsoleteFolder && AccessPermission.isEngOrConsult()),
      isBlocked: !AccessPermission.downloadSelectBlockedFiles(listFiles, currentUserPrivileges) ||
        (!AccessPermission.hasNoFolderSelected(listFiles) && AccessPermission.isEngOrConsult()) ||
        (selectedRowKeys.length > 1 && AccessPermission.isEngOrConsult() && !flags.downloadViaStream),
      disabled: isDownloading,
      action: () => {
        const blockedFiles = listFiles
          .filter((file) => {
            return selectedRowKeys.includes(
              file.Identifier.ApiId || file.Identifier.ItemId,
            );
          });
        const hasBlockedFiles = blockedFiles.some((file) => file.Status === 0);

        if (AccessPermission.hasNoFolderSelected(listFiles)) {
          if (
            openModalDownloadBlockedFiles &&
            AccessPermission.downloadSelectBlockedFiles(listFiles, currentUserPrivileges) &&
            hasBlockedFiles
          ) {
            if (selectedRowKeys.length > 1 && !flags.downloadViaStream) {
              if (AccessPermission.isEngOrConsult()) {
                if (openModalDownloadBlockedFiles) {
                  return openModalDownloadBlockedFiles(
                    false,
                    true,
                    false,
                    blockedFiles.length > 1 ? true : false,
                  );
                }
              } else {
                if (openModalDownloadMultiplesFiles) {
                  return openModalDownloadMultiplesFiles(false);
                }
              }
            }

            return openModalDownloadBlockedFiles(
              true,
              false,
              false,
              blockedFiles.length > 1 ? true : false,
            );
          }

          if (
            openModalDownloadBlockedFiles &&
            !AccessPermission.downloadSelectBlockedFiles(listFiles, currentUserPrivileges)
          ) {
            if (selectedRowKeys.length === 1 || AccessPermission.isEngOrConsult()) {
              return openModalDownloadBlockedFiles(false, true, false, false);
            }
            if (selectedRowKeys.length > 1) {
              return openModalDownloadBlockedFiles(false, false, false, true);
            }
          }

          if (selectedRowKeys.length > 1 && !flags.downloadViaStream) {
            if (AccessPermission.isEngOrConsult()) {
              if (openModalDownloadBlockedFiles) {
                return openModalDownloadBlockedFiles(false, false, false, true);
              }
            } else {
              if (openModalDownloadMultiplesFiles) {
                return openModalDownloadMultiplesFiles(false);
              }
            }
          }

          if (onDownload) { return onDownload(); }

        } else {
          if (AccessPermission.isEngOrConsult()) {
            if (openModalDownloadBlockedFiles) {
              return openModalDownloadBlockedFiles(false, false, true, false);
            }
          } else {
            if (openModalDownloadMultiplesFiles) {
              return openModalDownloadMultiplesFiles(true);
            }
          }
        }
      },
    },
  ];
};

const getDefaultToolbar: (input: IButtonsTableToolbar) => ITableActionTopbarButton[] = ({
  showEditTable,
  listFiles,
  obra,
  ObsoleteFolderId,
  breadCrumbItemId,
  openModalCriarPasta,
  dispatch,
  navigate,
  constructionSiteId,
  ConstructionSiteDisciplinesId,
  folderId,
  folderName,
  disciplineName,
  platform,
  urlFolder,
  breadCrumbPreviousItemId,
  isLoadingFilesObsoleteList,
  currentUserPrivileges,
  userInfo,
  currentTenant,
  tenantIds,
  onOpenHistoryDrawer,
  onRefetchFiles,
  resetResizableColumns,
}) => [
    {
      icon: getIconApi(platform),
      iconCustomSize: 16,
      description: ApisEnumLabel[platform],
      hidden: !AccessPermission.downloadFiles(currentUserPrivileges) || AccessPermission.isEngOrConsult(),
      isBlocked: !urlFolder,
      action: () => {
        if (urlFolder) {
          window.open(urlFolder, '_blank', 'noopener,noreferrer');

          if (disciplineName === folderName) {
            Mixpanel.track({
              name: 'REDIRECT_SA_ACTION',
              props: {
                constructionSiteId,
                api: platform,
                disciplineId: ConstructionSiteDisciplinesId,
                disciplineApiFolderId: folderId,
                disciplineName,
                folderName,
              },
              userInfo,
              currentListTenant: currentTenant,
              tenantIds,
            });

          } else {
            Mixpanel.track({
              name: 'REDIRECT_SA_ACTION',
              props: {
                constructionSiteId,
                api: platform,
                disciplineId: ConstructionSiteDisciplinesId,
                disciplineApiFolderId: folderId,
                disciplineName,
              },
              userInfo,
              currentListTenant: currentTenant,
              tenantIds,
            });
          }
        }
      },
      dropdownMenu: urlFolder
        ? undefined
        : (toggleDropdown: () => void) => (
          <ModalBloquedSADownload
            platform={platform}
            onCancel={() => toggleDropdown()}
          />
        ),
    },
    {
      icon: 'atualizar',
      iconCustomSize: 16,
      description: 'Atualizar',
      hidden: false,
      action: () => {
        const requestFileList: IListFilesRequest = {
          constructionSiteId,
          folderId,
          folderName,
          ignoreCache: true,
          isObsoleteFiles: false,
        };

        if (breadCrumbPreviousItemId != null) {
          requestFileList.breadCrumbId = breadCrumbPreviousItemId;
        }

        onRefetchFiles();
      },
    },
    {
      icon: 'history',
      iconCustomSize: 22,
      description: 'Histórico',
      action: () => {
        onOpenHistoryDrawer();
      },
    },
    {
      icon: 'arquivar',
      description: 'Nova pasta',
      hidden: !AccessPermission.editFiles(listFiles, currentUserPrivileges),
      action: () => {
        if (openModalCriarPasta) {
          openModalCriarPasta();
        }
      },
    },
    {
      icon: 'editar',
      description: 'Edição',
      hidden: !AccessPermission.editFiles(listFiles, currentUserPrivileges),
      action: () => {
        dispatch(ListagemArquivosActions.setShowEditTable(!showEditTable));
      },
    },
    {
      icon: 'listKanban',
      description: 'Redefinir colunas',
      action: () => resetResizableColumns(true),
    },
    {
      icon: 'obsoleteArchive',
      iconCustomSize: 16,
      description: 'Arquivos obsoletos',
      hidden: !AccessPermission.accessObsoleteFolder() || !ObsoleteFolderId,
      disabled: isLoadingFilesObsoleteList,
      action: () => {
        if (ObsoleteFolderId && !isLoadingFilesObsoleteList) {
          openFolder(
            obra.ConstructionSiteId || 0,
            ConstructionSiteDisciplinesId,
            ObsoleteFolderId,
            obra.Api,
            breadCrumbItemId,
            true,
            'Arquivos obsoletos',
            undefined,
            dispatch,
            navigate,
            disciplineName,
          );
        }
      },
      isLoading: isLoadingFilesObsoleteList,
      tooltipMessage: 'Não é possível ver os arquivos obsoletos enquanto houver versionamentos em andamento.',
    },
    {
      icon: 'upload',
      description: 'Upload de arquivos',
      hidden: !AccessPermission.uploadFiles(currentUserPrivileges),
      action: () => {
        document.getElementById('uploadFiles')?.click();
      },
    },
  ];

export const getButtonsPlotRequestTableToolbar: (
  allFilesCount: number,
  selectedFiles: number[],
  deleteRow: (index: number) => void,
  dispatch: React.Dispatch<any>,
  QRCodeIdPosition: QRCodePositionEnum,
  onQRCodeIdPosition: (id: number) => void,
  onSubmit: (
    allQrCode: boolean,
    allColors: boolean,
    allCopysCount: number,
    selectedFiles?: number[],
  ) => void,
  fileList: IRequestPlotColumns[],
) => ITableActionTopbarButton[] = (
  allFilesCount: number,
  selectedFiles: number[],
  deleteRow: (index: number) => void,
  dispatch: React.Dispatch<any>,
  QRCodeIdPosition: QRCodePositionEnum,
  onQRCodeIdPosition: (id: number) => void,
  onSubmit: (
    allQrCode: boolean,
    allColors: boolean,
    allCopysCount: number,
    selectedFiles?: number[],
  ) => void,
  fileList: IRequestPlotColumns[],
) => {
    return [
      {
        icon: QRCodePositionEnum[QRCodeIdPosition] as IconName,
        description: 'QR Code',
        showArrow: true,
        hidden: !!selectedFiles.length && (selectedFiles.length !== allFilesCount),
        action: () => undefined,
        dropdownMenu: (toggleDropdown: () => void) => (
          <QRCodePosition
            QRCodeIdPosition={QRCodeIdPosition}
            onQRCodeIdPosition={onQRCodeIdPosition}
          />
        ),
      },
      {
        icon: 'checkedOutline',
        description: !!selectedFiles.length && (selectedFiles.length !== allFilesCount)
          ? 'Aplicar'
          : 'Aplicar a todos',
        showArrow: true,
        action: () => undefined,
        dropdownMenu: (toggleDropdown: () => void) => (
          <LotePlotagens
            allFilesCount={allFilesCount}
            selectedFiles={selectedFiles}
            fileList={fileList}
            onSubmit={onSubmit}
            onClose={toggleDropdown}
          />
        ),
      },
      {
        icon: 'excluir',
        description: '',
        hidden: !selectedFiles.length,
        action: () => {
          selectedFiles.forEach((index) => deleteRow(index));
          dispatch(ListagemArquivosActions.setSelectedPlotRequestRowKeys([]));
        },
      },
    ];
  };

export const changeStatusFiles = (
  keys: string[],
  listFiles: IFileData[],
  constructionSiteId: number,
  folderId: string,
  status: FileStatusEnum,
  updateFilesStatus: (values: IUpdateFilesStatusRequest) => void,
  toggleDropdown: () => void,
) => {
  updateFilesStatus({
    fileApiIds: keys,
    status,
    constructionSiteFk: constructionSiteId,
    folderId,
  });
  toggleDropdown();
};

const getDropdownStatusChange = (
  keys: string[],
  listFiles: IFileData[],
  constructionSiteId: number,
  folderId: string,
  updateFilesStatus: (values: IUpdateFilesStatusRequest) => void,
  toggleDropdown: () => void,
) => (
  <div className={styles['menuStatusChange']}>
    <div
      className={styles['options']}
      onClick={() =>
        changeStatusFiles(
          keys,
          listFiles,
          constructionSiteId,
          folderId,
          FileStatusEnum.Bloqueado,
          updateFilesStatus,
          toggleDropdown,
        )
      }
    >
      Bloqueado
    </div>
    <div
      className={styles['options']}
      onClick={(e) =>
        changeStatusFiles(
          keys,
          listFiles,
          constructionSiteId,
          folderId,
          FileStatusEnum.Liberado,
          updateFilesStatus,
          toggleDropdown,
        )
      }
    >
      Liberado
    </div>
  </div>
);

export const getDragInfo = (folderName?: string) => (
  <div className={styles['dragInfoWrap']}>
    <img src={emptyListImage} alt='Upload arquivos' />
    <div className={styles['folderDescriptionWrap']}>
      <div>Arraste os arquivos para fazer upload em: </div>
      <div className={styles['folderName']}>{folderName}</div>
    </div>
  </div>
);

export const getDragError = (limitUpload?: number, folderName?: string) => (
  <div className={styles['dragErrorInfoWrap']}>
    <img src={emptyListImage} alt='Upload arquivos' />
    <div className={styles['folderDescriptionWrap']}>
      <div>
        {`Atenção: Não é possível realizar o upload de mais de ${limitUpload ? limitUpload : 10} arquivos simultaneamente`}
      </div>
      <div className={styles['folderName']}>{folderName}</div>
    </div>
  </div>
);

export const handleOpenFileLink = async (
  path: string,
  dispatch: Dispatch<any>,
  navigate: NavigateFunction,
) => {
  await dispatch(ViewerActions.setOpenFileLink(''));
  navigate(path);
};

export const openFolder = (
  csId: number,
  ConstructionSiteDisciplinesId: number,
  folderId: string,
  obraApi?: number,
  breadCrumbId?: number | string,
  isObsoleteFolder?: boolean,
  folderName?: string,
  event?: number,
  dispatch?: Dispatch<any>,
  navigate?: NavigateFunction,
  disciplineName?: string | null,
) => {
  let queryString = '';
  queryString += breadCrumbId
    ? `${queryString ? '&' : '?'}breadCrumbId=${breadCrumbId}`
    : '';
  queryString += isObsoleteFolder
    ? `${queryString ? '&' : '?'}isObsoleteFolder=${isObsoleteFolder}`
    : '';
  queryString += folderName
    ? `${queryString ? '&' : '?'}folderName=${folderName}`
    : '';
  queryString += obraApi
    ? `${queryString ? '&' : '?'}obraApi=${obraApi}`
    : '';
  queryString += ConstructionSiteDisciplinesId
    ? `${queryString ? '&' : '?'}ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}`
    : '';
  queryString += disciplineName
    ? `${queryString ? '&' : '?'}DisciplineName=${disciplineName}`
    : '';

  if (!event && dispatch && navigate) {
    handleOpenFileLink(
      `/obras/filelist/${csId}/${folderId}${queryString}`,
      dispatch,
      navigate,
    );
  } else {
    if (dispatch) {
      dispatch(ViewerActions.setOpenFileLink(`/obras/filelist/${csId}/${folderId}${queryString}`));
    }
  }
};

export const getCoordly2DViewerPath = (file: IFileData, breadCrumbId?: string | number) =>
  `/viewer/coordly/2d/${file?.FileInfo?.ConstructionSiteFk}/${file?.FileInfo?.ApiFolderId}/${file?.FileInfo?.ApiId}/${breadCrumbId}`;

export const handleOpenCoordly2DViewer = (navigate: NavigateFunction, file: IFileData, breadCrumbId?: string | number) => {
  if (!file || file.IsFolder) { return; }

  navigate(getCoordly2DViewerPath(file, breadCrumbId));
}

export const handleOpenCoordly3DViewer = (navigate: NavigateFunction, file: IFileData, breadCrumbId?: string | number) => {
  if (!file || file.IsFolder) { return; }

  navigate(`/viewer/coordly/3d/${file?.FileInfo?.ConstructionSiteFk}/${file?.FileInfo?.ApiFolderId}/${file?.FileInfo?.ApiId}/${breadCrumbId}`);
}

export interface IOpenFile {
  csId: number;
  folderId: string;
  ConstructionSiteDisciplinesId: number;
  record: IFileData;
  breadCrumbId: number | string;
  constructionSiteApiId: number;
  mouseClickEvent: number;
  userInfo?: IUserInforResponse;
  currentTenant?: ITenantData | null;
  tenantIds?: number[];
  disciplineName?: string | null;
  dispatch: Dispatch<any>;
  navigate: NavigateFunction;
  openModalVisualizationBlockedFiles?: (hasPermission: boolean) => void;
  setOpenFileVisualizationLinkStatus?: Dispatch<SetStateAction<IOpenVisualizationBlockedFileAction>>;
  openModalRenderUpgrade?: () => void;
}

export const handleOpenForgeViewer = ({
  csId,
  folderId,
  ConstructionSiteDisciplinesId,
  record,
  breadCrumbId,
  constructionSiteApiId,
  mouseClickEvent,
  userInfo,
  currentTenant,
  tenantIds,
  disciplineName,
  dispatch,
  navigate,
  openModalVisualizationBlockedFiles,
  setOpenFileVisualizationLinkStatus,
  openModalRenderUpgrade,
}: IOpenFile) => {
  const apiId = record?.FileInfo?.ApiId || record?.Identifier?.ApiId;
  const currentFolderId = folderId || record.FileInfo.ApiFolderId;

  if (extensions2dAnd3d.indexOf(record.Extension.toLocaleLowerCase()) !== -1) {
    if (record.RenderingStatus === 1 || (record.RenderingStatus === 2 && record.RenderingSignalR.etapa > 0)) {
      if ((record.Status === 0) && openModalVisualizationBlockedFiles && setOpenFileVisualizationLinkStatus) {
        if (AccessPermission.isEngOrConsult()) {
          return openModalVisualizationBlockedFiles(false);
        }
        setOpenFileVisualizationLinkStatus({
          path: `/viewer/1/${csId}/${currentFolderId}/${apiId}/${breadCrumbId}?obraApi=${constructionSiteApiId}${ConstructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}` : ''}`,
          newWindown: mouseClickEvent === 2,
        })
        return openModalVisualizationBlockedFiles(true);
      }
      if (dispatch && mouseClickEvent === 2) {
        dispatch(ViewerActions.setOpenFileLink(`/viewer/1/${csId}/${currentFolderId}/${apiId}/${breadCrumbId}?obraApi=${constructionSiteApiId}${ConstructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}` : ''}`));
      } else {
        handleOpenFileLink(
          `/viewer/1/${csId}/${currentFolderId}/${apiId}/${breadCrumbId}?obraApi=${constructionSiteApiId}${ConstructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}` : ''}`,
          dispatch,
          navigate,
        );
      }
    }
    else if (record.RenderingStatus === 3 && mouseClickEvent !== 2) {
      const request: IAutodeskViewer = {
        constructionSiteId: csId,
        folderId: currentFolderId || '',
        fileApiId: apiId
      };

      setFileStatusRendering(request, true);
      dispatch(ViewerActions.autoDeskViewer({
        ...request,
        onLimitedResources: openModalRenderUpgrade ? () => {
          resetFileStatusRendering(request);
          openModalRenderUpgrade();
        } : undefined,
      } as IAutodeskViewer));

      Mixpanel.track({
        name: 'JOB_RENDER_FILE',
        props: {
          constructionSiteId: csId,
          api: constructionSiteApiId,
          disciplineId: ConstructionSiteDisciplinesId,
          fileId: apiId,
          disciplineName,
          extension: record.Extension,
          federatedViewer: false,
        },
        userInfo,
        currentListTenant: currentTenant,
        tenantIds,
      });
    }
    else if ((record.RenderingStatus === null || record.RenderingStatus === 0) && mouseClickEvent !== 2) {
      const request: IAutodeskViewer = {
        constructionSiteId: csId,
        folderId: currentFolderId || '',
        fileApiId: apiId
      };

      setFileStatusRendering(request, false);
      dispatch(ViewerActions.autoDeskViewer({
        ...request,
        onLimitedResources: openModalRenderUpgrade ? () => {
          resetFileStatusRendering(request);
          openModalRenderUpgrade();
        } : undefined,
      } as IAutodeskViewer));

      Mixpanel.track({
        name: 'JOB_RENDER_FILE',
        props: {
          constructionSiteId: csId,
          api: constructionSiteApiId,
          disciplineId: ConstructionSiteDisciplinesId,
          fileId: apiId,
          disciplineName,
          extension: record.Extension,
          federatedViewer: false,
        },
        userInfo,
        currentListTenant: currentTenant,
        tenantIds,
      });
    }

  } else if (allOtherExtensions.indexOf(record.Extension.toLocaleLowerCase()) !== -1) {
    if ((record.Status === 0) && openModalVisualizationBlockedFiles && setOpenFileVisualizationLinkStatus) {
      if (AccessPermission.isEngOrConsult()) {
        return openModalVisualizationBlockedFiles(false);
      }
      setOpenFileVisualizationLinkStatus({
        path: `/viewer/2/${csId}/${currentFolderId}/${apiId}/${breadCrumbId}?obraApi=${constructionSiteApiId}${ConstructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}` : ''}`,
        newWindown: mouseClickEvent === 2,
      })
      return openModalVisualizationBlockedFiles(true);
    }
    if (dispatch && mouseClickEvent === 2) {
      dispatch(ViewerActions.setOpenFileLink(`/viewer/2/${csId}/${currentFolderId}/${apiId}/${breadCrumbId}?obraApi=${constructionSiteApiId}${ConstructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}` : ''}`));
    } else {
      handleOpenFileLink(
        `/viewer/2/${csId}/${currentFolderId}/${apiId}/${breadCrumbId}?obraApi=${constructionSiteApiId}${ConstructionSiteDisciplinesId ? `&ConstructionSiteDisciplinesId=${ConstructionSiteDisciplinesId}` : ''}`,
        dispatch,
        navigate,
      );
    }
  } else {
    toastHandler.showError('Arquivo inválido');
  }
};

export const getFilterOptions = (
  fileList: any[],
  key: string,
  render?: (value: any) => string,
  validation?: (index: any) => boolean,
  renderNode?: (value: any) => ReactNode,
) => {
  const types: any = {};
  const filterList: ITipoOption[] = [];
  fileList?.forEach((file) => {
    if (file[key] === undefined || file[key] === null) {
      return;
    }

    const updateIndex = render ? render(file[key]) : file[key];
    if (
      types[updateIndex] === undefined &&
      (!validation || (validation && validation(updateIndex)))
    ) {
      types[updateIndex] = true;
      filterList.push({
        description: updateIndex.toString(),
        renderNode: renderNode && renderNode(updateIndex),
        value: updateIndex.toString(),
      });
    }
  });
  return filterList;
};

export const getSecondPlanUploadFiles = (data: ISignalRArchive) => {
  if (data?.archiveStatus === 'error') {
    return (
      <Tooltip overlay={<div>Erro ao processar o upload</div>}>
        <div>
          <Icon
            icon='error'
            customSize={15}
            color='vermelho'
            style={{ cursor: 'pointer' }}
          />
        </div>
      </Tooltip>
    );
  }

  if (data.archiveStatus === 'success') {
    return (
      <Tooltip overlay={<div>Upload finalizado</div>}>
        <div>
          <Icon
            icon='confirmacao'
            customSize={15}
            color='verde'
          />
        </div>
      </Tooltip>
    );
  }

  if (data.archiveStatus === 'sendingStorage') {
    return (
      <Tooltip overlay={<div>{`Finalizando upload (${data.progress}%)`}</div>}>
        <div>
          <CircularProgressbar
            className={styles['secondPlanLoading']}
            strokeWidth={14}
            styles={buildStyles({ pathColor: '#3547C8', trailColor: '#EDEFF2' })}
            value={data.progress / 100}
            maxValue={1}
          />
        </div>
      </Tooltip>
    );
  }
};

type IListFilesValidOrderKey = 'name' | 'extension' | 'sizeInBytes' | 'revision' | 'lastUpdate' | 'status';

const tilePtBrMap: Record<IListFilesValidOrderKey, string> = {
  name: 'Nome',
  extension: 'Extensão',
  sizeInBytes: 'Tamanho',
  revision: 'Versão',
  lastUpdate: 'Modificado',
  status: 'Status',
};

export const getOrderTitle = (
  order: SortOrder,
  titleKey: IListFilesValidOrderKey,
) => {
  const titlePtBr = tilePtBrMap[titleKey];

  if (order === null) {
    return `Ordenar ${titlePtBr} Crescente`;
  }
  if (order === 'ascend') {
    return `Ordenar ${titlePtBr} Decrescente`;
  }
  return `Desabilitar Ordenação ${titlePtBr}`;
};

export const SELECTION_COLUMN_WIDTH = 40;

export const getResizableColumnWidth = (
  width: number,
  preferencesFeature: boolean,
): Record<string, number> => {
  const atLeastMin = (id: string, value: number) =>
    Math.max(value, minWidthResizableColumns[id]);

  const widths: Record<string, number> = {
    [RESIZABLE_COLUMN_IDS.Extension]: atLeastMin(
      RESIZABLE_COLUMN_IDS.Extension, width * 0.08),
    [RESIZABLE_COLUMN_IDS.SizeInBytes]: atLeastMin(
      RESIZABLE_COLUMN_IDS.SizeInBytes, width * 0.1),
    [RESIZABLE_COLUMN_IDS.RenderingStatus]: atLeastMin(
      RESIZABLE_COLUMN_IDS.RenderingStatus, width * 0.12),
    [RESIZABLE_COLUMN_IDS.Versions]: atLeastMin(
      RESIZABLE_COLUMN_IDS.Versions, width * (preferencesFeature ? 0.11 : 0.15)),
    [RESIZABLE_COLUMN_IDS.LastUpdate]: atLeastMin(
      RESIZABLE_COLUMN_IDS.LastUpdate, width * 0.15),
    [RESIZABLE_COLUMN_IDS.Status]: atLeastMin(
      RESIZABLE_COLUMN_IDS.Status, width * 0.1),
    [RESIZABLE_COLUMN_IDS.Action]: preferencesFeature
      ? atLeastMin(RESIZABLE_COLUMN_IDS.Action, width * 0.04)
      : 0,
  };

  const others = Object.values(widths).reduce((sum, w) => sum + w, 0);
  widths[RESIZABLE_COLUMN_IDS.Name] = atLeastMin(
    RESIZABLE_COLUMN_IDS.Name,
    width - SELECTION_COLUMN_WIDTH - others,
  );

  return widths;
};

export const minWidthResizableColumns: Record<string, number> = {
  [RESIZABLE_COLUMN_IDS.Name]: 232,
  [RESIZABLE_COLUMN_IDS.Extension]: 110,
  [RESIZABLE_COLUMN_IDS.SizeInBytes]: 125,
  [RESIZABLE_COLUMN_IDS.RenderingStatus]: 145,
  [RESIZABLE_COLUMN_IDS.Versions]: 131,
  [RESIZABLE_COLUMN_IDS.LastUpdate]: 175,
  [RESIZABLE_COLUMN_IDS.Status]: 120,
  [RESIZABLE_COLUMN_IDS.Action]: 50,
};

export const getResizableColumnStorageKey = (userId: string, csId: number) => {
  return `listagem-arquivos-columns-width-${userId}-${csId}`;
};
